import React from 'react'
import _ from "lodash"
import {renderIf} from "../../../Shared";
import ResponsiveTextLabel from "../../../../components/ResponsiveTextLabel/ResponsiveTextLabel";
import {Link} from "react-router-dom";
import {getLinkToDetailRow} from "../../Codi/codiHelpers";
import getTitle from "../../../../helpers/getTitle";
import useTranslate from "../../../../modules/local/useTranslate";
import classNames from "classnames";
import TooltipApp from "components/TooltipApp";

export const GodWordCardItem = ({item, onClick, Wrapper = 'div', className}) => {

    const t = useTranslate()
    const codi_doc = _.get(item, 'codi_document_row')

    return (
        <Wrapper
            className={classNames("flex flex-center relative shadow-lg rounded-3xl", className)}
            style={{
                minHeight: 200,
                padding: '1rem 2rem',
                backgroundPosition: 'center',
                backgroundSize: 'cover',
            }}>
            {renderIf(
                item && item?.content,
                <div
                    style={{ fontFamily: "'Montserrat', sans-serif" }}
                    className="flex flex-col flex-center gap-4">
                    <div
                        onClick={onClick}
                        className={classNames(
                            "p-4 background rounded-3xl font-medium text-green-600 leading-7",
                            onClick && 'hover:text-primary-700 cursor-pointer',
                        )}>
                        {renderIf(
                            item?.content,
                            <ResponsiveTextLabel text={item?.content}/>
                        )}
                    </div>
                    <TooltipApp
                        placement="right"
                        title={
                            <div className="flex flex-col">
                            <span className="font-medium text-sm leading-tight">
                                {getTitle(_.get(codi_doc, 'codi_document'))}
                            </span>
                                <span className="text-xs text-color-400">
                                {`( ${t('click to see bible')} )`}
                            </span>
                            </div>
                        }
                        classNames={{root: "font-medium text-xs italic"}}>
                        <div className="px-3 py-1 w-fit mx-auto bg-white-30 border border-white-50 rounded-full flex flex-center gap-4">
                            <div style={{ height: 1 }} className="w-5 bg-primary-400" />
                            <Link
                                to={getLinkToDetailRow(codi_doc) || "#"}
                                target="_blank"
                                className="font-semibold text-sm md:text-lg text-primary no-underline">
                                {item?.source_text}
                            </Link>
                            <div style={{ height: 1 }} className="w-5 bg-primary-400" />
                        </div>
                    </TooltipApp>
                </div>
            )}
        </Wrapper>
    )
}
